import React from 'react';
import { useStyles } from './styles';

interface StadiumLabelProps {
  text: string;
}

const StadiumLabel: React.FC<StadiumLabelProps> = ({ text }) => {
  const classes = useStyles();
  const status = text?.replaceAll(' ', '') ?? '';
  const textClass = `stadiumLabelText${status}`;
  const labelClass = `stadiumLabel${status}`;

  return (
    <div className={`${classes.stadiuemLabel} ${classes[labelClass]}`}>
      <span className={`${classes.stadiumLabelText} ${classes[textClass]}`}>
        {text}
      </span>
    </div>
  );
};

export default StadiumLabel;
